export default [{
    path: "/log/index",
    redirect: "/operation-log",
    component: resolve => {
        require(["@/views/log/index.vue"], resolve);
    },
    meta: {
        active: ['/log/index'],
        navtype: 1,
    },
    children: [
        {
            path: "/operation-log",
            component: resolve => require(["@/views/log/operation-log/index.vue"], resolve),
            meta: {
                active: ['/log/index'],
                towActive: "/operation-log",
                navtype: 1,
                bread: [
                    { title: "日志管理", to: "/operation-log" },
                    { title: "操作日志" }
                ]
            }
        },
        {
            path: "/call-log",
            component: resolve => require(["@/views/log/call-log/index.vue"], resolve),
            meta: {
                active: ['/log/index'],
                towActive: "/call-log",
                navtype: 1,
                bread: [
                    { title: "日志管理", to: "/operation-log" },
                    { title: "调用日志" }
                ]
            }
        }
    ]
}]